import { formatKeyword } from './keywords';
import { getPaperStatusName as TgetPaperStatusName, getValidationStatusName } from './translations';
import { TFunction } from 'i18next';
import { Submission } from '../store/submission/types';
import { getFullName } from './users';
import { columnOperator } from '../store/table/types';
import i18next from '../i18n';
import { store } from '../store/store';
import { selectKeywordsLevels } from '../store/selectors';
import { getPaperStatusName } from './submission';

export const COLUMN_OPERATORS: { [key in columnOperator]: { label: string } } = {
  avg_word_count: {
    label: i18next.t('Average word count'),
  },
  aggregate: {
    label: i18next.t('Aggregate'),
  },
  count: {
    label: i18next.t('Count'),
  },
  average: {
    label: i18next.t('Average'),
  },
  min: {
    label: i18next.t('Min'),
  },
  max: {
    label: i18next.t('Max'),
  },
  reviewer_names: {
    label: i18next.t('Name of reviewers'),
  },
  num_assignments: {
    label: i18next.t('Number of assignments'),
  },
  num_reviews_completed: {
    label: i18next.t('Number of reviews completed'),
  },
  pct_reviews_completed: {
    label: i18next.t('Percentage of reviews completed'),
  },
  assigned_submission_ids: {
    label: i18next.t('Assigned submission IDs'),
  },
  num_bids: {
    label: i18next.t('Number of bids'),
  },
  bidding_completed: {
    label: i18next.t('Bidding completed'),
  },
};

export const formatKeywordColumn = (newRegister: Record<any, any>, keywordById: { [key: number]: Keyword }): void => {
  const state = store.getState();
  const keywordsLevels = selectKeywordsLevels(state);

  newRegister.keywords = newRegister.keyword_ids.map((id: number) => formatKeyword(id, keywordById)).join(';');
  // Add main area field
  if (newRegister.keyword_ids.length > 0) {
    const firstKeyword = keywordById[newRegister.keyword_ids[0]];
    if (keywordsLevels == 1) {
      newRegister.main_area = firstKeyword.name;
    } else if (firstKeyword.parent_id) {
      newRegister.main_area = keywordById[firstKeyword.parent_id].name;
    }
  }
};

export const isQuestionColumn = (fieldId: string): boolean => {
  return fieldId.startsWith('question_');
};

export const isCustomColumn = (fieldId: string): boolean => {
  return fieldId.startsWith('custom_');
};

export const getSubmissionRow = (
  submission: Submission,
  canViewAuthors: boolean,
  keywordById: { [key: number]: Keyword },
  t: TFunction<'translation', undefined>,
): Submission => {
  const row = { ...submission };

  // Fill keyword information
  formatKeywordColumn(row, keywordById);

  // @ts-ignore
  row.authors_str = canViewAuthors ? row.authors.map((author) => getFullName(author)).join(', ') : t('Not visible');

  // @ts-ignore
  row.author_emails = canViewAuthors ? row.authors.map((author) => author.email).join(', ') : t('Not visible');

  // @ts-ignore
  row.paper_status = TgetPaperStatusName(getPaperStatusName(submission), t);

  // @ts-ignore
  row.file_upload_str = row.file_upload?.filename_original;

  // @ts-ignore
  row.validation_status = getValidationStatusName(row.validation_status, t);

  return row;
};
